import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { Box, Button, Paper, Stack, TextField, Typography } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import axios from "axios";
import { DateTime } from "luxon";
import React, { useState } from "react";
import { toast } from "react-toastify";

type Props = {};

const ExportSimulation: React.FC<Props> = () => {
    const [fromDate, setFromDate] = useState<DateTime | null>(null);
    const [toDate, setToDate] = useState<DateTime | null>(null);
    const [loading, setLoading] = useState(false);

    const handleDownload = async () => {
        if (!fromDate || !toDate) {
            toast.error("Please provide both dates.");
            return;
        }

        const from = fromDate.toFormat("yyyy-MM-dd");
        const to = toDate.toFormat("yyyy-MM-dd");
        const url = `http://localhost:9000/api/v1/simulation/export?from=${from}&to=${to}`;

        setLoading(true);
        try {
            const response = await axios.get(url, {
                responseType: "blob",
            });

            const blob = new Blob([response.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const urlBlob = window.URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = urlBlob;
            link.download = `simulation_export_${from}_${to}.xlsx`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            window.URL.revokeObjectURL(urlBlob);
            toast.success("Export completed successfully");
        } catch (error) {
            toast.error(`Error: ${axios.isAxiosError(error) ? error.message : "Unknown Error"}`);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Paper elevation={0} sx={{ p: 3, borderRadius: 2 }}>
            <Typography variant="h6" gutterBottom>
                Simulation Export
            </Typography>

            <Stack direction={{ xs: "column", sm: "row" }} spacing={2} sx={{ mb: 3 }}>
                <DatePicker
                    label="From Date"
                    value={fromDate}
                    onChange={(newValue) => setFromDate(newValue)}
                    slots={{
                        textField: (params) => <TextField {...params} fullWidth size="small" />,
                    }}
                />

                <DatePicker
                    label="To Date"
                    value={toDate}
                    onChange={(newValue) => setToDate(newValue)}
                    slots={{
                        textField: (params) => <TextField {...params} fullWidth size="small" />,
                    }}
                />
            </Stack>

            <Box display="flex" justifyContent="flex-end">
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleDownload}
                    disabled={loading || !fromDate || !toDate}
                    startIcon={<FileDownloadIcon />}
                >
                    {loading ? "Exporting..." : "Export Excel"}
                </Button>
            </Box>
        </Paper>
    );
};

export default ExportSimulation;
